import React from "react";

const Menu = ({ menu }) => (
  <>
    {menu.map(function (item, index) {
      return (
        <li key={index} className="menu-list">
          {item.isLink
          ?
            <a 
              href={item.menuLink} 
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.menuName}
            </a>
          :
            <a 
              href={`#${item.menuSlug}`} 
              rel="noopener noreferrer"
            >
              {item.menuName}
            </a>
          }
        </li>
      );
    })}
  </>
);

export default Menu;
